import { render, staticRenderFns } from "./workDays.vue?vue&type=template&id=65a89a76"
import script from "./workDays.vue?vue&type=script&lang=js"
export * from "./workDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports